export default "__VITE_ASSET__8e2e4213__"